import { Button } from "@mui/material";
import { useState } from "react";
import AddImageState from "./AddImageState";
import { useMutation, useQuery } from "react-query";
import { deleteFn, getFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import VariantImageCard from "./VariantImageCard";
import CustomModal from "../../../shared/CustomModal";
import { toast } from "react-toastify";

const MultipleVariantImage = ({ open, handleClose, variantId }) => {
  const [state, setState] = useState(0);
  const [editImage, setEditImageId] = useState();

  const handleCloseFn = () => {
    setState(0);
    handleClose();
  };

  const { data: imageData, refetch } = useQuery(
    ["multipleImageData"],
    () =>
      getFn({ product_variant_value: variantId }, API_URLS.multipleImageApi),
    {
      enabled: open,
      select: (data) => data?.data?.data,
    }
  );

  const { mutate: deleteImage } = useMutation(
    (reqBody) => deleteFn(reqBody, API_URLS.multipleImageApi),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          refetch();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleDelete = (id) => {
    deleteImage({
      product_variant_value: variantId,
      product_variant_image_ids: [id],
    });
  };

  return (
    <CustomModal
      title={
        state === 0 ? "Variant Image" : `${editImage ? "Update" : "Add"} Image`
      }
      open={open}
      onClose={handleCloseFn}
    >
      {state === 0 ? (
        <div>
          <div
            className={`flex relative p-2 gap-x-3 w-full h-[40vh] overflow-auto ${
              imageData?.length === 0 ? "bg-white" : "bg-orange-100"
            }  bg-opacity-70`}
          >
            <div>
              <div className="grid  grid-cols-3 py-4 gap-x-3 gap-y-3">
                {imageData?.map((item, idx) => (
                  <VariantImageCard
                    key={idx}
                    item={item}
                    setState={setState}
                    setEditImageId={setEditImageId}
                    handleDelete={handleDelete}
                  />
                ))}
                {!imageData?.length > 0 && (
                  <img
                    src="https://img.freepik.com/free-vector/hand-drawn-no-data-concept_52683-127823.jpg"
                    alt=""
                    className="absolute !w-[60%] !mx-[20%]  h-[90%] z-20"
                  />
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-between mt-1">
            <Button
              onClick={handleCloseFn}
              variant="contained"
              color="warning"
              className="!py-2 !mt-3"
            >
              CANCEL
            </Button>

            <Button
              onClick={() => setState(1)}
              variant="contained"
              color="success"
              className="!py-2 !mt-3"
            >
              +Add
            </Button>
          </div>
        </div>
      ) : (
        <AddImageState
          editImageId={editImage}
          setEditImageId={setEditImageId}
          setState={setState}
          variantId={variantId}
        />
      )}
    </CustomModal>
  );
};

export default MultipleVariantImage;
